export default (theme) => ({
    root: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        pointerEvents: 'none',
        '&, & *': {
            boxSizing: 'border-box',
        },
    },
    transition: {
        alignItems: 'center',
        justifyContent: 'center',
        // `overflow: visible` Needed to make the CopilotBar "rainbow" border & shadows visible
        overflow: 'visible !important',
    },
    container: {
        backgroundColor: theme.colors.primary.white,
        borderRadius: 16,
        boxShadow:
            '0px 4px 5px 0px #273C5033, 0px 3px 14px 0px #273C501F, 0px 8px 10px 0px #273C5024',
        maxWidth: '100%',
        minHeight: 64,
        pointerEvents: 'auto',
        position: 'relative',
        top: 2,
        transition: 'all 0.3s ease-in-out',
        width: 600,
        '&::before': {
            background: 'var(--ssm-promoGradient)',
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            content: '""',
            height: 16,
            left: 0,
            position: 'absolute',
            right: 0,
            top: -4,
            zIndex: -1,
        },
        '& [class*="RichText__isBasic"] .ProseMirror': {
            ...theme.utils.scrollbar,
            maxHeight: 'inherit',
            overflow: 'auto',
        },
    },
    chatToolbar: {
        padding: '2px 16px 2px 8px',
        flex: 1,
    },
    pinnedToRight: {
        right: 0,
    },
    cancelButton: {
        marginBottom: 11,
        marginRight: 16,
    },
    toggleButton: {
        marginBottom: 10,
        padding: '9px 4px 9px 16px',
        position: 'relative',
        '& > [class*="Icon__root"]': {
            borderRadius: 4,
            backgroundColor: theme.colors.utility.transparent,
            padding: 2,
            transition: 'background-color 0.2s ease',
            '&:hover': {
                backgroundColor: theme.colors.actionMinor[100],
            },
        },
    },
    loadingContainer: {
        alignItems: 'center',
        display: 'flex',
        flex: 1,
        height: 64,
        justifyContent: 'center',
        padding: 16,
    },
    transitionBlock: {
        left: 0,
        position: 'absolute',
        right: 0,
        top: 0,
    },
    contentWrapper: {
        alignItems: 'flex-end',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        width: '100%',
    },
    feedbackContainer: {
        flex: '1 1 100%',
        overflow: 'hidden',
        padding: '12px 44px 0',
    },
});
